
export enum Role {
    Admin = "admin",
    User = "user",
		ABB = "abb",
    None = "",
}
